import React from "react";
import { TableHeadersType } from "../../../constant/tableHeadersConstants/tableHeadersType";
import {
  AllOpenJobChecklistDataType,
  JobSingleType,
} from "../../../commonTypes/jobsType";
import { Progress } from "reactstrap";
import "./style.scss";
import { CheckCircleDarkIcon, PendingIcon } from "../../../assets/images";
import { Link } from "react-router-dom";

type AppProps = {
  data: AllOpenJobChecklistDataType[] | [];
  tableHeader: TableHeadersType[];
  history?: any;
  jobSingleData: JobSingleType | null | number;
  dispatchResetAllOpenJobChecklistSingleData: () => void;
  isAllOpenJobCheckListDetailPresent?: boolean;
};

const CheckListModalData = ({
  data,
  tableHeader,
  history,
  jobSingleData,
  dispatchResetAllOpenJobChecklistSingleData,
  isAllOpenJobCheckListDetailPresent
}: AppProps) => {
  const renderTableData = () => {
    let finalData = data?.map((item: AllOpenJobChecklistDataType) => {
      return (
        <tr key={item?._id}>
          {tableHeader?.length &&
            tableHeader?.map((header: TableHeadersType | any) => {
              if (header?.value === "checklist_name") {
                return (
                  <td style={{ wordBreak: "break-all" }}>
                    {item?.checklist_title}
                  </td>
                );
              } else if (header?.value === "checklist_status") {
                return (
                  <td>
                    <div>
                      <div>
                        <Progress
                          striped
                          style={{
                            height: "15px",
                            marginRight: "10px",
                            width: "100%",
                            backgroundColor: "#bfcbe1",
                          }}
                          value={item?.status_count}
                          max={item?.total_status}
                          color={
                            item?.status_count < item?.total_status
                              ? "warning"
                              : "success"
                          }
                        ></Progress>
                      </div>
                      <div className="d-flex justify-content-between mt-1">
                        <div>
                          {item?.status_count}/{item?.total_status}
                        </div>
                        <div
                          className={
                            item?.status_count < item?.total_status
                              ? "warning"
                              : "success"
                          }
                        >
                          <span className="pr-1">
                            <img
                              width={18}
                              src={
                                item?.status_count < item?.total_status
                                  ? PendingIcon
                                  : CheckCircleDarkIcon
                              }
                              alt="progess"
                            />
                          </span>
                          {item?.status_count < item?.total_status
                            ? "In Progress"
                            : "Completed"}
                        </div>
                      </div>
                    </div>
                  </td>
                );
              } else if (header?.value === "action") {
                return (
                  <td>
                    {isAllOpenJobCheckListDetailPresent &&
                      <div
                        onClick={() => {
                          dispatchResetAllOpenJobChecklistSingleData();
                          history?.push(
                            `/all-open-jobs/checklist/${item?._id}/${(jobSingleData as JobSingleType)?.job_id ? (jobSingleData as JobSingleType)?.job_id : jobSingleData}`
                          );
                        }}
                      >
                        <span
                          style={{
                            verticalAlign: "middle",
                            cursor: "pointer",
                            color: "#dd4433",
                          }}
                        >
                          View Checklist
                        </span>
                      </div>
                    }
                  </td>
                );
              } else {
                return <td> --/-- </td>;
              }
            })}
        </tr>
      );
    });
    return finalData;
  };
  return <>{renderTableData()}</>;
};

export default CheckListModalData;
